import Vue from 'vue'
import Router from 'vue-router'

import error from '@/error';
import pdf from '@/pdf.vue'
import arbitrary from '@/views/arbitrary/arbitrary'
import brandStory from '@/views/brand-story/brand-story'
import brandCulture from '@/views/brand-story/brand-culture/brand-culture'
import brandHistory from '@/views/brand-story/brand-history/brand-history'
import originalityStory from '@/views/brand-story/originality-story/originality-story'
import home from '@/views/home/home'
import motorbikeDetails from '@/views/motorbike-details/motorbike-details'
import newsTidal from '@/views/news-tidal/news-tidal'
import activity from '@/views/news-tidal/activity/activity'
import appraisal from '@/views/news-tidal/appraisal/appraisal'
import newsTidalDetails from '@/views/news-tidal/news-tidal-details/news-tidal-details'
import trends from '@/views/news-tidal/trends/trends'
import serve from '@/views/serve/serve'
import feedback from '@/views/serve/feedback/feedback'
import maintain from '@/views/serve/maintain/maintain'
import travelService from '@/views/serve/travel-service/travel-service'
import warrantyCoverage from '@/views/serve/warranty-coverage/warranty-coverage'
import shop from '@/views/test-drive/shop/shop'
import testDrive from '@/views/test-drive/shop/shop'
import testDrives from '@/views/test-drive/test-drives/test-drives'
import tojoinList from '@/views/test-drive/tojoin/tojoin-list'
import tojoinWrite from '@/views/test-drive/tojoin/tojoin-write/tojoin-write'

Vue.use(Router)
export default new Router({
    mode: 'history',
    // base: __dirname,
    //linkActiveClass: 'active', // 更改激活状态的Class值
    linkexactActiveClass:'active',
    routes:[

        {
            path:'/',
            name:'home',
            component:home
        },
        {
            path:'/home',
            name:'index',
            component:home
        },
      {
        path:'/pdf',
        name:'Pdf',
        component:pdf
      },
        {
            path:'/error',
            name:'error',
            component:error
        },
        // 这里开始
        {
            path:'/arbitrary',
            name:'arbitrary',
            component:arbitrary
        },
        {
            path:'/brand-story',
            name:'brandStory',
            component:brandStory,
            children:[
                {
                    path:'/brand-culture',
                    name:'brandCulture',
                    component:brandCulture
                },{
                    path:'/brand-history',
                    name:'brandHistory',
                    component:brandHistory
                },{
                    path:'/originality-story',
                    name:'originalityStory',
                    component:originalityStory
                },
            ]
        },
        {
            path:'/motorbike-details',
            name:'motorbikeDetails',
            component:motorbikeDetails
        },
        {
            path:'/news-tidal',
            name:'newsTidal',
            component:newsTidal,
            children:[
                {
                    path:'/activity',
                    name:'activity',
                    component:activity,
                },{
                    path:'/appraisal',
                    name:'appraisal',
                    component:appraisal,
                },{
                    path:'/news-tidal-details',
                    name:'newsTidalDetails',
                    component:newsTidalDetails,
                },{
                    path:'/trends',
                    name:'trends',
                    component:trends,
                },
            ]
        },
        {
            path:'/serve',
            name:'serve',
            component:serve,
            children:[
                {
                    path:'/feedback',
                    name:'feedback',
                    component:feedback,
                },{
                    path:'/maintain',
                    name:'maintain',
                    component:maintain,
                },{
                    path:'/travel-service',
                    name:'travelService',
                    component:travelService,
                },{
                    path:'/warranty-coverage',
                    name:'warrantyCoverage',
                    component:warrantyCoverage,
                },
            ]
        },
        {
            path:'/shop',
            name:'shop',
            component:shop
        },
        {
            path:'/test-drive',
            name:'testDrive',
            component:testDrive
        },
        {
            path:'/test-drives',
            name:'testDrives',
            component:testDrives
        },
        {
            path:'/tojoin-list',
            name:'tojoinList',
            component:tojoinList
        },
        {
            path:'/tojoin-write',
            name:'tojoinWrite',
            component:tojoinWrite
        },
        {path:'*',redirect:'/home'}
    ]
})



//////////////////
// WEBPACK FOOTER
// ./router/index.js
// module id = xC5m
// module chunks = 1